import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { AuthService, DynamicState, ENVIRONMENT_TOKEN, EnvironmentService, MainState, PortalLibModule, UtilityService } from '@cloud-and-service/portal-lib';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { provideUserIdleConfig } from 'angular-user-idle';
import { pendingRequestsInterceptor$ } from 'ng-http-loader';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { PipesModule } from './app/pipes/pipes.module';
import { appInitializer } from './app/services/app.initializer';
import { CallBackService } from './app/services/callback.service';
import { ErrorHandlerService } from './app/services/error-handler.service';
import { ErrorInterceptor } from './app/services/error.interceptor';
import { JwtInterceptor } from './app/services/jwt-interceptor';
import { environment } from './environments/environment';


if (environment.mode == 'production') {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(), importProvidersFrom(
            BrowserModule,
            FormsModule,
            CommonModule,
            PipesModule,
            NgxChartsModule,
            ReactiveFormsModule,
            ModalModule,
            BsDatepickerModule,
            BsDropdownModule,
            TabsModule,
            NgxsModule.forRoot([MainState, DynamicState]),
            NgxsStoragePluginModule.forRoot({ keys: [MainState, DynamicState] }),
            NgxsReduxDevtoolsPluginModule.forRoot(),
            ToastrModule.forRoot(),
            PopoverModule,
            PortalLibModule.forRoot(),
        ),
        CallBackService,
        UtilityService,
        provideAppInitializer(() => {
            const initializerFn = appInitializer(inject(AuthService), inject(EnvironmentService), inject(Router));
            return initializerFn();
        }),
        provideUserIdleConfig({ idle: 720, timeout: 180, ping: 10 }),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideHttpClient(withInterceptors([pendingRequestsInterceptor$]), withInterceptorsFromDi()),
        { provide: ENVIRONMENT_TOKEN, useValue: environment },
        {
            provide: ErrorHandler,
            useClass: ErrorHandlerService,
        },
        provideAnimations(),
        provideRouter(routes, withComponentInputBinding()),
    ]
})
    .catch((err) => console.error(err));
